const createNode = (tagNode, attributes) => Object.assign(document.createElement(tagNode), attributes);
const bodyClientWidth = () =>
      document.body.clientWidth ||
      document.body.scrollWidth ||
      document.body.offsetWidth;
const detectMobile = () => {
    let userAg = window.navigator.userAgent ?? navigator.userAgent;
    let navigRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
    let isMobile = navigRegex.test(userAg) || document.documentElement.classList.contains('bx-touch');
    return isMobile;
  }
const loadDom = (fn) => document.readyState === "loading" ?
    window.addEventListener("DOMContentLoaded", fn) :
    fn();

/*mask inputs*/
const getNumbersValue = function(input){
  return input.value.replace(/\D/g, "");
}
const inputValues = function(e){
  let input = e.target,
      inputNumber = getNumbersValue(input),
      formatedValue = "";
      
  if(!inputNumber) {
    return input.value = "";
  }
  if(input.value.length != input.selectionStart){
    if(e.data && /\D/g.test(e.data)){
      
    }
  }
  if(["7", "8", "9"].indexOf(inputNumber[0]) > -1){
    if(inputNumber[0] == "9") inputNumber = "7" + inputNumber;
    
    let firstNumber = inputNumber[0] == "8" ? "8" : "+7";
    formatedValue = firstNumber + "";
    if(inputNumber.length > 1) {
      formatedValue += " (" + inputNumber.substring(1,4);
    }
    if(inputNumber.length >= 5) {
      formatedValue += ") " + inputNumber.substring(4,7);
    }
    if(inputNumber.length >= 8){
      formatedValue += "-" + inputNumber.substring(7,9);
    }
    if(inputNumber.length >= 10){
      formatedValue += "-" + inputNumber.substring(9,11);
    }
  }else{
    formatedValue += "+" + inputNumber.substring(0,16);
  }
  if(input.value.length != input.selectionStart){
    if(e.data && /\D/g.test(e.data)){
      input.value = formatedValue;
    }
    return;
  }
  input.value = formatedValue;
}
const formatInputTel = function(nodes){
  if(nodes.length != 0 && !nodes.length) return;
  
  for(let i = 0; i < nodes.length; i++){
    let input = nodes[i];
    input.addEventListener('input', inputValues);
  }
}
const noticeModal = function(data, noticeVar){
  if(!data) return;
  const wrapModal = createNode('div', {
    className: 'notice',
  });
  const contentNotice = createNode('div', {
    className: 'notice__content notice-content',
  });
  const contentNoticeAction = createNode('div', {
    className: 'notice-content__action',
  })
  if(noticeVar === 'addBasket'){
    wrapModal.classList.add('notice--extend');
    // content block
    const contentNoticeImageBlock = createNode('div', {
      className: 'notice-content__box',
    });
    const contentNoticeImage = createNode('img', {
      className: 'notice-content__img db',
      width:100,
      heigth: 100,
      alt: data.itemAddBasket.NAME,
      src: data.prodImag,
    });
    
    contentNoticeImageBlock.appendChild(contentNoticeImage);
    contentNotice.appendChild(contentNoticeImageBlock);
    
    const contentNoticeName = createNode('p', {
    className: 'notice-content__name mr-reset',
    textContent: data.itemAddBasket.NAME,
    });
    
    contentNoticeAction.appendChild(contentNoticeName);
    //close block
    const closeContentNotice = createNode('div', {
      className: 'notice__close notice-close',
    });
    const closeContentNoticeBtn = createNode('button', {
      className: 'notice-close__btn btn-reset',
    });
    const closeContentNoticeText = createNode('p', {
      className: 'notice-close__text mr-reset',
      textContent: 'Добавлен в корзину'
    });
    closeContentNotice.appendChild(closeContentNoticeText);
    closeContentNotice.appendChild(closeContentNoticeBtn);
    contentNoticeAction.appendChild(closeContentNotice);
  }
  if(noticeVar === 'sendMail'){
    const contentNoticeImageBlock = createNode('div', {
      className: 'notice-content__box',
    });
    const contentNoticeImage = createNode('img', {
      className: 'notice-content__img db',
      width:50,
      heigth: 50,
      alt: "Успешная отправка",
      src: 'data:image/webp;base64,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',
    });
    
    contentNoticeImageBlock.appendChild(contentNoticeImage);
    contentNotice.appendChild(contentNoticeImageBlock);
    
    wrapModal.classList.add('notice--simple');
    const closeContentNoticeText = createNode('p', {
      className: 'notice-close__text mr-reset',
      textContent: 'Ваше сообщение отправлено'
    });
    contentNoticeAction.appendChild(closeContentNoticeText);
  }
  
  contentNotice.appendChild(contentNoticeAction);
  wrapModal.appendChild(contentNotice);
  document.body.appendChild(wrapModal);

  return wrapModal;
}

async function supportsWebP() {
  const webpData = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4TAYAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
  const blob = await fetch(webpData).then(r => r.blob());

  return createImageBitmap(blob).then(() => true, () => false);
}